import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ConnexionComponent } from './connexion.component';
import { CaisseAutoCompleteComponent } from './caisse-auto-complete/caisse-auto-complete.component';
import { AppRoutingModule } from '../../app-routing.module';
import { SharedModule } from '@shared/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ForgotLoginComponent } from './forgot-login/forgot-login.component';
import { OtpConnexionComponent } from '@modules/connexion/otp-connexion/otp-connexion.component';
@NgModule({
    declarations: [
        ConnexionComponent,
        OtpConnexionComponent,
        CaisseAutoCompleteComponent,
        ForgotLoginComponent,
    ],
    imports: [
        CommonModule,
        BrowserModule,
        FormsModule,
        AppRoutingModule,
        SharedModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatAutocompleteModule,
    ],
    exports: [
        ConnexionComponent,
        OtpConnexionComponent,
        CaisseAutoCompleteComponent,
        CommonModule,
        BrowserModule,
        FormsModule,
        AppRoutingModule,
    ],
})
export class ConnexionModule {}
